export default "__VITE_ASSET__BHuCXJQ___"